export default "/countdown-crate-eth.3943c565c65f4c6ff9b979973cb60318.svg";